import { h, Host } from "@stencil/core";
import { theme } from "@eventstore-ui/theme";
import { ICON_NAMESPACE } from "../../icons/namespace";
/**
 * Calls out a piece of information.
 * @part heading - Targets the heading text.
 * @part icon - Targets the icon.
 */
export class EsCallout {
    constructor() {
        this.getIcon = () => {
            if (this.icon)
                return this.icon;
            switch (this.variant) {
                case 'error':
                case 'warning':
                    return [ICON_NAMESPACE, 'warning'];
                case 'info':
                    return [ICON_NAMESPACE, 'info'];
                case 'tip':
                default:
                    return [ICON_NAMESPACE, 'lightbulb'];
            }
        };
        this.heading = undefined;
        this.variant = 'tip';
        this.icon = undefined;
    }
    render() {
        return (h(Host, { key: '402081df18deb0b7255137247d8e80cdcb547765', "high-contrast": theme.isHighContrast() }, h("es-icon", { key: '1bfaee998adf38ac129414324fae36a073282b5e', part: 'icon', icon: this.getIcon(), size: 26 }), h("h1", { key: 'aeecf40ae476c273cfade4987e1d1452c25e84a6', part: 'heading' }, this.heading), h("slot", { key: '60d17f33b5a791b7d9391cb9502eed36dfae7e2b' })));
    }
    static get is() { return "es-callout"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-callout.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-callout.css"]
        };
    }
    static get properties() {
        return {
            "heading": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Heading text."
                },
                "attribute": "heading",
                "reflect": false
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "EsCalloutVariant",
                    "resolved": "\"error\" | \"info\" | \"tip\" | \"warning\"",
                    "references": {
                        "EsCalloutVariant": {
                            "location": "local",
                            "path": "/home/runner/work/Design-System/Design-System/packages/components/src/components/es-callout/es-callout.tsx",
                            "id": "src/components/es-callout/es-callout.tsx::EsCalloutVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Which color set to use."
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "'tip'"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconDescription",
                    "resolved": "[namespace: string | symbol, name: string] | string | undefined",
                    "references": {
                        "IconDescription": {
                            "location": "import",
                            "path": "../../components/es-icon/types",
                            "id": "src/components/es-icon/types.ts::IconDescription"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Override the variant icon."
                },
                "attribute": "icon",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=es-callout.js.map
